import React from 'react';
import { useSelector } from 'react-redux';
import Assets from '../../../general/assets';
import FilePicker from '../filePicker';
import { Copy, Help, SystemText } from '@salesperformanceint/e4shared';
import './files.css';
import { apiGet } from 'services';

export const Files = ({
    id,
    help,
    error,
    label,
    value,
    onChange,
    allowMultiple,
    extensions,
    maxSize,
    folder,
    fileValidation,
    hideDelete,
    mediaOnly,
    allowedSources,
    modalInModal,
    readonly,
    profileIds,
    anonymous,
    mandatory,
    buttonLabel,
    ...extraProps
}) => {
    const [assets, setAssets] = React.useState([]);
    const [invalid, setInvalid] = React.useState([]);
    const [showPicker, setShowPicker] = React.useState(false);
    const showFormHelp = useSelector(state => state.ui.showFormHelp);

    const { user } = useSelector(state => state.user);

    React.useEffect(() => {
        if (value) {
            allowMultiple && Array.isArray(value) && setAssets(value);
            !allowMultiple && setAssets([value]);
        } else {
            setAssets([]);
        }
    }, [value]);

    React.useEffect(() => {
        const courses = assets.filter(x => x.source === 'accelerate').map(x => x.internal_Id);
        if (!anonymous && courses?.length && profileIds?.length) {
            apiGet(
                `integrations/accelerate-check?profiles=${profileIds.join(',')}&courses=${courses.join(',')}`,
                user.guid,
                response => {
                    setInvalid(response);
                }
            );
        }
    }, [assets, profileIds]);

    React.useEffect(() => {
        const courses = assets.filter(x => x.source === 'learn2').map(x => x.internal_Id);
        if (!anonymous && courses?.length && profileIds?.length) {
            apiGet(
                `integrations/learn2-check?profiles=${profileIds.join(',')}&courses=${courses.join(',')}`,
                user.guid,
                response => {
                    setInvalid(response);
                }
            );
        }
    }, [assets, profileIds]);

    const removeFile = remove => {
        const newFiles = assets.filter(
            f =>
                (f.name !== remove.name || f.source !== remove.source) &&
                (!f.childAsset || f.childAsset.name !== remove.name || f.childAsset.source !== remove.source)
        );
        setAssets(newFiles);
        if (onChange) {
            const mapped = newFiles.map(a => ({ ...a }));
            if (allowMultiple) {
                onChange(mapped);
            } else {
                onChange(mapped.find(x => true));
            }
        }
    };

    const addFiles = assets => {
        setAssets(assets);
        if (onChange) {
            const mapped = assets.map(a => ({ ...a, id: 0 }));
            if (allowMultiple) {
                onChange(mapped);
            } else {
                onChange(mapped.find(x => true));
            }
        }
    };

    return (
        <div {...extraProps} key={id} id={id} className={`form-group ${error || invalid?.length > 0 ? 'has-error' : ''}`}>
            {label && (
                <label htmlFor="item-name">
                    {label}
                    {mandatory && <span className="mandatory">*</span>}
                </label>
            )}
            {showFormHelp && help && (
                <span className="form-control-help">
                    <Copy value={help} />
                </span>
            )}
            <div className="mb10 mt5">
                <button
                    id="choose-button"
                    data-testid="choose-button"
                    disabled={readonly}
                    className={`btn btn-${error ? 'danger' : 'primary'} mb5`}
                    onClick={() => setShowPicker(true)}
                >
                    <i className="fa fa-plus-circle mr10" />
                    {buttonLabel
                        ? buttonLabel
                        : allowMultiple
                          ? SystemText('Admin/Forms/Files/Buttons/ChooseResource/Plural')
                          : SystemText('Admin/Forms/Files/Buttons/ChooseResource')}
                </button>
            </div>
            {assets && assets.length > 0 ? (
                <div className="files-displayed">
                    <Assets
                        onOpenPicker={() => setShowPicker(true)}
                        assets={assets}
                        onDelete={hideDelete || readonly ? null : removeFile}
                    />
                </div>
            ) : (
                <div className="files-displayed">
                    <div className="">
                        {allowMultiple
                            ? SystemText('Admin/Forms/Files/NoResource/Plural')
                            : SystemText('Admin/Forms/Files/NoResource')}
                    </div>
                </div>
            )}
            <FilePicker
                show={showPicker}
                onClose={() => setShowPicker(false)}
                onAdd={addFiles}
                allowMultiple={allowMultiple}
                extensions={extensions}
                maxSize={maxSize}
                folder={folder}
                value={assets}
                fileValidation={fileValidation}
                allowedSources={allowedSources}
                mediaOnly={mediaOnly}
                modalInModal={modalInModal}
                profileIds={profileIds}
                anonymous={anonymous}
            />
            {invalid?.length > 0 && (
                <div className="mt5 text-danger">
                    {SystemText('Admin/Forms/Files/InvalidAccelerate')}
                    <Help id="help-invalid-users">
                        <div className="mb10">{SystemText('Admin/Forms/Files/InvalidAccelerate/Header')}</div>
                        {invalid.map(p => {
                            return <div key={`invalid-${p.id}`}>{p.full_Name}</div>;
                        })}
                    </Help>
                </div>
            )}
            {!invalid?.length && error && <div className="mt5 text-danger">{error}</div>}
        </div>
    );
};

export default Files;
